@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Header Section - Brand Style -->
<div
  class="relative mb-4 overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe: red + teal brand colors -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #e53e3e 0%,
        #e53e3e 40%,
        #0f766e 40%,
        #0f766e 100%
      );
    "
  ></div>
  <div
    class="flex items-center justify-between px-5 py-3 relative flex-wrap gap-2"
  >
    <!-- Decorative background elements -->
    <div
      class="absolute inset-0"
      style="pointer-events: none; overflow: hidden"
    >
      <!-- Dot grid pattern -->
      <div
        class="absolute inset-0"
        style="
          opacity: 0.15;
          background-image: radial-gradient(
            circle,
            #0f766e 1px,
            transparent 1px
          );
          background-size: 20px 20px;
        "
      ></div>
      <!-- Crosshatch pattern overlay -->
      <div
        class="absolute inset-0"
        style="
          opacity: 0.06;
          background-image: repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            ),
            repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            );
        "
      ></div>
      <!-- Filled circles -->
      <div
        class="absolute"
        style="
          right: 115px;
          top: -8px;
          width: 65px;
          height: 65px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.12);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 185px;
          bottom: -12px;
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.1);
        "
      ></div>
      <!-- Dashed circles -->
      <div
        class="absolute"
        style="
          right: 75px;
          bottom: 0px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px dashed rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 160px;
          top: 5px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px dashed rgba(229, 62, 62, 0.2);
        "
      ></div>
      <!-- Small solid dots -->
      <div
        class="absolute"
        style="
          right: 250px;
          top: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 230px;
          bottom: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.22);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 145px;
          bottom: 5px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.2);
        "
      ></div>
    </div>
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <!-- Icon -->
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(229, 62, 62, 0.25);
        "
      >
        <svg
          style="width: 20px; height: 20px; color: #fff"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          ></path>
        </svg>
      </div>
      <div>
        @if (clntDtls && clntDtls.length > 0) {
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
        }
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #e53e3e;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            Trips & Routes Analytics
          </p>
        </div>
      </div>
    </div>
    <!-- Right: Action buttons -->
    <div class="relative flex items-center flex-wrap" style="gap: 8px">
      @if (fromUrbanDashboard) {
      <button
        (click)="goBackToDashboard()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0"
        onmouseenter="this.style.background='#e2e8f0'"
        onmouseleave="this.style.background='#f1f5f9'"
      >
        <svg
          style="width: 14px; height: 14px"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 17l-5-5m0 0l5-5m-5 5h12"
          ></path>
        </svg>
        Go Back
      </button>
      } @if (filters == true) {
      <button
        (click)="fltrs()"
        class="flex items-center gap-1.5 px-4 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #0f766e; color: #ffffff; border: none"
        onmouseenter="this.style.background='#115e59'"
        onmouseleave="this.style.background='#0f766e'"
      >
        <span
          nz-icon
          nzType="filter"
          nzTheme="outline"
          style="font-size: 12px"
        ></span>
        <span>Hide Filters</span>
      </button>
      } @if (filters == false) {
      <button
        (click)="fltrs()"
        class="flex items-center gap-1.5 px-4 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #0f766e; color: #ffffff; border: none"
        onmouseenter="this.style.background='#115e59'"
        onmouseleave="this.style.background='#0f766e'"
      >
        <span
          nz-icon
          nzType="filter"
          nzTheme="outline"
          style="font-size: 12px"
        ></span>
        <span>Show Filters</span>
      </button>
      }
    </div>
  </div>
</div>

<div class="mx-auto px-3">
  <!-- Filter Section -->
  @if (filters) {
  <div
    class="bg-white rounded-lg p-4 mb-4 fltrsctn"
    style="border: 1px solid #e5e7eb; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04)"
  >
    <div class="flex items-center gap-3 flex-wrap">
      <!-- Date Filter -->
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          style="
            font-size: 13px;
            font-weight: 600;
            color: #64748b;
            margin-bottom: 6px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          "
          >Date</label
        >
        <nz-date-picker
          [nzDisabledDate]="disabledDate"
          [nzFormat]="dateFormat"
          [(ngModel)]="slctdDt"
          (ngModelChange)="onChange($event)"
          class="filter-input w-full"
        >
        </nz-date-picker>
      </div>
      <!-- Vendor Filter -->
      @if (ShowClap) {
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          style="
            font-size: 13px;
            font-weight: 600;
            color: #64748b;
            margin-bottom: 6px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          "
          >Vendor</label
        >
        <nz-select
          class="filter-input w-full"
          nzShowSearch
          nzPlaceHolder="Select Vendor"
          [(ngModel)]="selectedvndr"
          (ngModelChange)="onvndrSelect($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          @if (!showVndr) {
          <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
          } @for (v of vendorList; track v) {
          <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm"></nz-option>
          }
        </nz-select>
      </div>
      }
    </div>
  </div>
  }

  <!-- ═══════════════════════════════════════════════════════ -->
  <!-- Overview Metrics Section                               -->
  <!-- ═══════════════════════════════════════════════════════ -->
  @if (ttlTrpsCnt && ttlTrpsCnt.length > 0) {
  <div>
    <!-- ── ULBs, Vehicles & Trips — Single Row ── -->
    <div class="ds-overview-row ds-section">
      <!-- ULBs -->
      @if (allUlbWiseData && allUlbWiseData.length > 0) {
      <div class="ds-container">
        <div class="ds-container-header ds-header-blue">
          <div class="flex items-center gap-2">
            <svg
              style="width: 18px; height: 18px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
              ></path>
            </svg>
            <span class="ds-container-title">ULBs</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          <div class="ds-equal-grid ds-grid-2">
            <div
              class="ds-card ds-neutral"
              [class.ds-selected]="selectedUlbCard === 'ulb_total'"
              (click)="onUlbCardClick('ulb_total')"
            >
              <div class="ds-value">{{ tntLst.length }}</div>
              <div class="ds-label">Total</div>
            </div>
            <div
              class="ds-card ds-positive"
              [class.ds-selected]="selectedUlbCard === 'ulb_trip_defined'"
              (click)="onUlbCardClick('ulb_trip_defined')"
            >
              <div class="ds-value ds-teal">{{ trpCreatedUlbs }}</div>
              <div class="ds-label">Trip Defined</div>
            </div>
            <div
              class="ds-card ds-negative"
              [class.ds-selected]="selectedUlbCard === 'ulb_trip_not_defined'"
              (click)="onUlbCardClick('ulb_trip_not_defined')"
            >
              <div class="ds-value ds-red">
                {{ tntLst.length - trpCreatedUlbs }}
              </div>
              <div class="ds-label">Trip Not Def.</div>
            </div>
            <div
              class="ds-card ds-positive"
              [class.ds-selected]="selectedUlbCard === 'ulb_route_defined'"
              (click)="onUlbCardClick('ulb_route_defined')"
            >
              <div class="ds-value ds-green">{{ rteDfndUlbs }}</div>
              <div class="ds-label">Route Defined</div>
            </div>
            <div
              class="ds-card ds-negative"
              [class.ds-selected]="selectedUlbCard === 'ulb_route_not_defined'"
              (click)="onUlbCardClick('ulb_route_not_defined')"
            >
              <div class="ds-value ds-red">
                {{ trpCreatedUlbs - rteDfndUlbs }}
              </div>
              <div class="ds-label">Route Not Def.</div>
            </div>
          </div>
        </div>
      </div>
      }
      <!-- Vehicles -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-purple">
          <div class="flex items-center gap-2">
            <svg
              style="width: 18px; height: 18px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
              ></path>
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
              ></path>
            </svg>
            <span class="ds-container-title">Vehicles</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          <div class="ds-equal-grid ds-grid-2">
            <div
              class="ds-card ds-neutral"
              [class.ds-selected]="selectedCard === '0_all_vhcls'"
              (click)="onCardClick(0, 'all_vhcls', 'All Vehicles')"
            >
              <div class="ds-value">{{ ttlTrpsCnt[0].ttl_vhcls || 0 }}</div>
              <div class="ds-label">Total</div>
            </div>
            <div
              class="ds-card ds-positive"
              [class.ds-selected]="selectedCard === '0_trips_vhcls_defined'"
              (click)="
                onCardClick(
                  0,
                  'trips_vhcls_defined',
                  'Vehicles - Trips Defined'
                )
              "
            >
              <div class="ds-value ds-teal">
                {{ ttlTrpsCnt[0].trps_asgnd_vhcls || 0 }}
              </div>
              <div class="ds-label">Trips Def.</div>
            </div>
            <div
              class="ds-card ds-negative"
              [class.ds-selected]="selectedCard === '0_trips_vhcls_not_defined'"
              (click)="
                onCardClick(
                  0,
                  'trips_vhcls_not_defined',
                  'Vehicles - Trips Not Defined'
                )
              "
            >
              <div class="ds-value ds-red">
                {{ ttlTrpsCnt[0].trps_not_asgnd_vhcls || 0 }}
              </div>
              <div class="ds-label">Trips Not Def.</div>
            </div>
            <div
              class="ds-card ds-positive"
              [class.ds-selected]="selectedCard === '0_routes_vhcls_defined'"
              (click)="
                onCardClick(
                  0,
                  'routes_vhcls_defined',
                  'Vehicles - Routes Defined'
                )
              "
            >
              <div class="ds-value ds-teal">
                {{ ttlTrpsCnt[0].rts_dfnd_vhcls || 0 }}
              </div>
              <div class="ds-label">Routes Def.</div>
            </div>
            <div
              class="ds-card ds-negative"
              [class.ds-selected]="
                selectedCard === '0_routes_vhcls_not_defined'
              "
              (click)="
                onCardClick(
                  0,
                  'routes_vhcls_not_defined',
                  'Vehicles - Routes Not Defined'
                )
              "
            >
              <div class="ds-value ds-red">
                {{ ttlTrpsCnt[0].rts_not_dfnd_vhcls || 0 }}
              </div>
              <div class="ds-label">Routes Not Def.</div>
            </div>
            <div
              class="ds-card ds-neutral"
              [class.ds-selected]="selectedCard === '0_single_trip'"
              (click)="onCardClick(0, 'single_trip', 'Vehicles - Single Trip')"
            >
              <div class="ds-value ds-muted">
                {{ ttlTrpsCnt[0].sngl_trp_vhcls || 0 }}
              </div>
              <div class="ds-label">Single Trip</div>
            </div>
            <div
              class="ds-card ds-neutral"
              [class.ds-selected]="selectedCard === '0_multiple_trips'"
              (click)="
                onCardClick(0, 'multiple_trips', 'Vehicles - Multiple Trips')
              "
            >
              <div class="ds-value ds-muted">
                {{ ttlTrpsCnt[0].mltpl_trp_vhcls || 0 }}
              </div>
              <div class="ds-label">Multiple Trips</div>
            </div>
          </div>
        </div>
      </div>
      <!-- Trips (narrower) -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-amber">
          <div class="flex items-center gap-2">
            <svg
              style="width: 18px; height: 18px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
              ></path>
            </svg>
            <span class="ds-container-title">Trips</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          <!-- Defined — full width -->
          <div
            class="ds-card ds-neutral"
            style="margin-bottom: 10px"
            [class.ds-selected]="selectedCard === '0_trips_defined'"
            (click)="onCardClick(0, 'trips_defined', 'All Trips - Defined')"
          >
            <div class="ds-value">{{ ttlTrpsCnt[0].tdy_trps || 0 }}</div>
            <div class="ds-label">Defined</div>
          </div>
          <!-- Travelled & Not Travelled — side by side -->
          <div class="ds-equal-grid ds-grid-1">
            <div
              class="ds-card ds-positive"
              [class.ds-selected]="selectedCard === '0_trips_travelled'"
              (click)="
                onCardClick(0, 'trips_travelled', 'All Trips - Travelled')
              "
            >
              <div class="ds-value ds-green">
                {{ ttlTrpsCnt[0].tdy_trvl_trps || 0 }}
              </div>
              <div class="ds-label">Travelled</div>
            </div>
            <div
              class="ds-card ds-negative"
              [class.ds-selected]="selectedCard === '0_trips_not_travelled'"
              (click)="
                onCardClick(
                  0,
                  'trips_not_travelled',
                  'All Trips - Not Travelled'
                )
              "
            >
              <div class="ds-value ds-red">
                {{ ttlTrpsCnt[0].tdy_nt_trvl_trps || 0 }}
              </div>
              <div class="ds-label">Not Travelled</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ── Primary & Secondary ── -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 ds-section">
      <!-- Primary -->
      <div class="ds-container ds-bg-primary">
        <div class="ds-container-header">
          <div class="flex items-center gap-2">
            <span class="ds-accent-bar ds-bar-blue"></span>
            <span class="ds-container-title">Primary</span>
            <span class="ds-container-badge"
              >{{ ttlTrpsCnt[0].primary_ttl_vhcls || 0 }} vehicles</span
            >
          </div>
          <button
            class="ds-nav-btn"
            (click)="navigateTo('tripCvrge-dashboard')"
            title="Go to Trip Coverage Dashboard"
          >
            <svg
              style="width: 16px; height: 16px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.5"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </button>
        </div>
        <div class="ds-container-body">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <!-- Trips Vehicles Group -->
            <div>
              <div class="ds-group-title">Trips Vehicles</div>
              <div class="grid grid-cols-2 gap-3">
                <div
                  class="ds-card-sm ds-positive"
                  [class.ds-selected]="selectedCard === '1_trips_vhcls_defined'"
                  (click)="
                    onCardClick(
                      1,
                      'trips_vhcls_defined',
                      'Primary - Trips Vehicles Defined'
                    )
                  "
                >
                  <div class="ds-value-sm">
                    {{ ttlTrpsCnt[0].primary_trps_asgnd_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Defined</div>
                </div>
                <div
                  class="ds-card-sm ds-negative"
                  [class.ds-selected]="
                    selectedCard === '1_trips_vhcls_not_defined'
                  "
                  (click)="
                    onCardClick(
                      1,
                      'trips_vhcls_not_defined',
                      'Primary - Trips Vehicles Not Defined'
                    )
                  "
                >
                  <div class="ds-value-sm ds-red">
                    {{ ttlTrpsCnt[0].primary_trps_not_asgnd_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Not Def.</div>
                </div>
                <div
                  class="ds-card-sm ds-neutral"
                  [class.ds-selected]="selectedCard === '1_single_trip'"
                  (click)="
                    onCardClick(1, 'single_trip', 'Primary - Single Trip')
                  "
                >
                  <div class="ds-value-sm ds-muted">
                    {{ ttlTrpsCnt[0].primary_sngl_trp_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Single</div>
                </div>
                <div
                  class="ds-card-sm ds-neutral"
                  [class.ds-selected]="selectedCard === '1_multiple_trips'"
                  (click)="
                    onCardClick(1, 'multiple_trips', 'Primary - Multiple Trips')
                  "
                >
                  <div class="ds-value-sm ds-muted">
                    {{ ttlTrpsCnt[0].primary_mltpl_trp_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Multiple</div>
                </div>
              </div>
            </div>
            <!-- Routes Vehicles Group -->
            <div>
              <div class="ds-group-title">Routes Vehicles</div>
              <div class="grid grid-cols-2 gap-3">
                <div
                  class="ds-card-sm ds-positive"
                  [class.ds-selected]="
                    selectedCard === '1_routes_vhcls_defined'
                  "
                  (click)="
                    onCardClick(
                      1,
                      'routes_vhcls_defined',
                      'Primary - Routes Vehicles Defined'
                    )
                  "
                >
                  <div class="ds-value-sm">
                    {{ ttlTrpsCnt[0].primary_rts_dfnd_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Defined</div>
                </div>
                <div
                  class="ds-card-sm ds-negative"
                  [class.ds-selected]="
                    selectedCard === '1_routes_vhcls_not_defined'
                  "
                  (click)="
                    onCardClick(
                      1,
                      'routes_vhcls_not_defined',
                      'Primary - Routes Vehicles Not Defined'
                    )
                  "
                >
                  <div class="ds-value-sm ds-red">
                    {{ ttlTrpsCnt[0].primary_rts_not_dfnd_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Not Def.</div>
                </div>
              </div>
            </div>
            <!-- Trips Group -->
            <div>
              <div class="ds-group-title">Trips</div>
              <div class="grid grid-cols-3 gap-3">
                <div
                  class="ds-card-sm ds-neutral"
                  [class.ds-selected]="selectedCard === '1_trips_defined'"
                  (click)="
                    onCardClick(1, 'trips_defined', 'Primary - Trips Defined')
                  "
                >
                  <div class="ds-value-sm">
                    {{ ttlTrpsCnt[0].primary_def_trps || 0 }}
                  </div>
                  <div class="ds-label-sm">Defined</div>
                </div>
                <div
                  class="ds-card-sm ds-positive"
                  [class.ds-selected]="selectedCard === '1_trips_travelled'"
                  (click)="
                    onCardClick(
                      1,
                      'trips_travelled',
                      'Primary - Trips Travelled'
                    )
                  "
                >
                  <div class="ds-value-sm ds-green">
                    {{ ttlTrpsCnt[0].primary_trvl_trps || 0 }}
                  </div>
                  <div class="ds-label-sm">Travelled</div>
                </div>
                <div
                  class="ds-card-sm ds-negative"
                  [class.ds-selected]="selectedCard === '1_trips_not_travelled'"
                  (click)="
                    onCardClick(
                      1,
                      'trips_not_travelled',
                      'Primary - Trips Not Travelled'
                    )
                  "
                >
                  <div class="ds-value-sm ds-red">
                    {{ ttlTrpsCnt[0].primary_nt_trvl_trps || 0 }}
                  </div>
                  <div class="ds-label-sm">Not Trvl.</div>
                </div>
              </div>
            </div>
            <!-- Routes Group -->
            <div>
              <div class="ds-group-title">Routes</div>
              <div class="grid grid-cols-3 gap-3">
                <div
                  class="ds-card-sm ds-neutral"
                  [class.ds-selected]="selectedCard === '1_routes_defined'"
                  (click)="
                    onCardClick(1, 'routes_defined', 'Primary - Routes Defined')
                  "
                >
                  <div class="ds-value-sm">
                    {{ ttlTrpsCnt[0].primary_rts_dfnd || 0 }}
                  </div>
                  <div class="ds-label-sm">Defined</div>
                </div>
                <div
                  class="ds-card-sm ds-positive"
                  [class.ds-selected]="selectedCard === '1_routes_tracked'"
                  (click)="
                    onCardClick(1, 'routes_tracked', 'Primary - Routes Tracked')
                  "
                >
                  <div class="ds-value-sm ds-green">
                    {{ ttlTrpsCnt[0].primary_trckd_rts || 0 }}
                  </div>
                  <div class="ds-label-sm">Tracked</div>
                </div>
                <div
                  class="ds-card-sm ds-warn"
                  [class.ds-selected]="selectedCard === '1_routes_deviated'"
                  (click)="
                    onCardClick(
                      1,
                      'routes_deviated',
                      'Primary - Routes Deviated'
                    )
                  "
                >
                  <div class="ds-value-sm ds-amber">
                    {{ ttlTrpsCnt[0].primary_rte_dvtd || 0 }}
                  </div>
                  <div class="ds-label-sm">Deviated</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Secondary -->
      <div class="ds-container ds-bg-secondary">
        <div class="ds-container-header">
          <div class="flex items-center gap-2">
            <span class="ds-accent-bar ds-bar-amber"></span>
            <span class="ds-container-title">Secondary</span>
            <span class="ds-container-badge"
              >{{ ttlTrpsCnt[0].secondary_ttl_vhcls || 0 }} vehicles</span
            >
          </div>
          <button
            class="ds-nav-btn"
            (click)="navigateTo('scndrytripCvrge-dashboard')"
            title="Go to Secondary Trip Coverage Dashboard"
          >
            <svg
              style="width: 16px; height: 16px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.5"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </button>
        </div>
        <div class="ds-container-body">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <!-- Trips Vehicles Group -->
            <div>
              <div class="ds-group-title">Trips Vehicles</div>
              <div class="grid grid-cols-2 gap-3">
                <div
                  class="ds-card-sm ds-positive"
                  [class.ds-selected]="selectedCard === '2_trips_vhcls_defined'"
                  (click)="
                    onCardClick(
                      2,
                      'trips_vhcls_defined',
                      'Secondary - Trips Vehicles Defined'
                    )
                  "
                >
                  <div class="ds-value-sm">
                    {{ ttlTrpsCnt[0].secondary_trps_asgnd_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Defined</div>
                </div>
                <div
                  class="ds-card-sm ds-negative"
                  [class.ds-selected]="
                    selectedCard === '2_trips_vhcls_not_defined'
                  "
                  (click)="
                    onCardClick(
                      2,
                      'trips_vhcls_not_defined',
                      'Secondary - Trips Vehicles Not Defined'
                    )
                  "
                >
                  <div class="ds-value-sm ds-red">
                    {{ ttlTrpsCnt[0].secondary_trps_not_asgnd_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Not Def.</div>
                </div>
                <div
                  class="ds-card-sm ds-neutral"
                  [class.ds-selected]="selectedCard === '2_single_trip'"
                  (click)="
                    onCardClick(2, 'single_trip', 'Secondary - Single Trip')
                  "
                >
                  <div class="ds-value-sm ds-muted">
                    {{ ttlTrpsCnt[0].secondary_sngl_trp_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Single</div>
                </div>
                <div
                  class="ds-card-sm ds-neutral"
                  [class.ds-selected]="selectedCard === '2_multiple_trips'"
                  (click)="
                    onCardClick(
                      2,
                      'multiple_trips',
                      'Secondary - Multiple Trips'
                    )
                  "
                >
                  <div class="ds-value-sm ds-muted">
                    {{ ttlTrpsCnt[0].secondary_mltpl_trp_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Multiple</div>
                </div>
              </div>
            </div>
            <!-- Routes Vehicles Group -->
            <div>
              <div class="ds-group-title">Routes Vehicles</div>
              <div class="grid grid-cols-2 gap-3">
                <div
                  class="ds-card-sm ds-positive"
                  [class.ds-selected]="
                    selectedCard === '2_routes_vhcls_defined'
                  "
                  (click)="
                    onCardClick(
                      2,
                      'routes_vhcls_defined',
                      'Secondary - Routes Vehicles Defined'
                    )
                  "
                >
                  <div class="ds-value-sm">
                    {{ ttlTrpsCnt[0].secondary_rts_dfnd_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Defined</div>
                </div>
                <div
                  class="ds-card-sm ds-negative"
                  [class.ds-selected]="
                    selectedCard === '2_routes_vhcls_not_defined'
                  "
                  (click)="
                    onCardClick(
                      2,
                      'routes_vhcls_not_defined',
                      'Secondary - Routes Vehicles Not Defined'
                    )
                  "
                >
                  <div class="ds-value-sm ds-red">
                    {{ ttlTrpsCnt[0].secondary_rts_not_dfnd_vhcls || 0 }}
                  </div>
                  <div class="ds-label-sm">Not Def.</div>
                </div>
              </div>
            </div>
            <!-- Trips Group -->
            <div>
              <div class="ds-group-title">Trips</div>
              <div class="grid grid-cols-3 gap-3">
                <div
                  class="ds-card-sm ds-neutral"
                  [class.ds-selected]="selectedCard === '2_trips_defined'"
                  (click)="
                    onCardClick(2, 'trips_defined', 'Secondary - Trips Defined')
                  "
                >
                  <div class="ds-value-sm">
                    {{ ttlTrpsCnt[0].secondary_def_trps || 0 }}
                  </div>
                  <div class="ds-label-sm">Defined</div>
                </div>
                <div
                  class="ds-card-sm ds-positive"
                  [class.ds-selected]="selectedCard === '2_trips_travelled'"
                  (click)="
                    onCardClick(
                      2,
                      'trips_travelled',
                      'Secondary - Trips Travelled'
                    )
                  "
                >
                  <div class="ds-value-sm ds-green">
                    {{ ttlTrpsCnt[0].secondary_trvl_trps || 0 }}
                  </div>
                  <div class="ds-label-sm">Travelled</div>
                </div>
                <div
                  class="ds-card-sm ds-negative"
                  [class.ds-selected]="selectedCard === '2_trips_not_travelled'"
                  (click)="
                    onCardClick(
                      2,
                      'trips_not_travelled',
                      'Secondary - Trips Not Travelled'
                    )
                  "
                >
                  <div class="ds-value-sm ds-red">
                    {{ ttlTrpsCnt[0].secondary_nt_trvl_trps || 0 }}
                  </div>
                  <div class="ds-label-sm">Not Trvl.</div>
                </div>
              </div>
            </div>
            <!-- Routes Group -->
            <div>
              <div class="ds-group-title">Routes</div>
              <div class="grid grid-cols-3 gap-3">
                <div
                  class="ds-card-sm ds-neutral"
                  [class.ds-selected]="selectedCard === '2_routes_defined'"
                  (click)="
                    onCardClick(
                      2,
                      'routes_defined',
                      'Secondary - Routes Defined'
                    )
                  "
                >
                  <div class="ds-value-sm">
                    {{ ttlTrpsCnt[0].secondary_rts_dfnd || 0 }}
                  </div>
                  <div class="ds-label-sm">Defined</div>
                </div>
                <div
                  class="ds-card-sm ds-positive"
                  [class.ds-selected]="selectedCard === '2_routes_tracked'"
                  (click)="
                    onCardClick(
                      2,
                      'routes_tracked',
                      'Secondary - Routes Tracked'
                    )
                  "
                >
                  <div class="ds-value-sm ds-green">
                    {{ ttlTrpsCnt[0].secondary_trckd_rts || 0 }}
                  </div>
                  <div class="ds-label-sm">Tracked</div>
                </div>
                <div
                  class="ds-card-sm ds-warn"
                  [class.ds-selected]="selectedCard === '2_routes_deviated'"
                  (click)="
                    onCardClick(
                      2,
                      'routes_deviated',
                      'Secondary - Routes Deviated'
                    )
                  "
                >
                  <div class="ds-value-sm ds-amber">
                    {{ ttlTrpsCnt[0].secondary_rte_dvtd || 0 }}
                  </div>
                  <div class="ds-label-sm">Deviated</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- ULB Wise Grid Section -->
  <div
    class="bg-white rounded-lg mb-4 overflow-hidden ulb-grid-section"
    style="border: 1px solid #e5e7eb; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05)"
    id="ulbGridSection"
  >
    <div
      class="flex items-center gap-2 px-4 py-2.5"
      style="border-bottom: 1px solid #f1f5f9"
    >
      <div
        class="flex items-center justify-center"
        style="
          width: 28px;
          height: 28px;
          background: #f1f5f9;
          border-radius: 6px;
        "
      >
        <svg
          style="width: 14px; height: 14px; color: #475569"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          ></path>
        </svg>
      </div>
      <span
        style="
          font-size: 14px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        "
        >ULB Wise Trips & Routes</span
      >
    </div>
    <app-data-grid
      [totalItems]="gridTotals0"
      style="width: 100%; max-width: 100% !important"
      [dataSource]="ulbWiseData"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="false"
      [groupPanel]="false"
      [columnChooser]="false"
      [allowExport]="true"
      exportFileName="ULB Wise Trips Routes"
      [pageSize]="20"
      [allowedPageSizes]="[10, 20, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [wordWrapEnabled]="true"
    >
      <app-grid-column
        dataField="sno"
        caption="S.No"
        [minWidth]="55"
        [width]="60"
        alignment="center"
      ></app-grid-column>

      <app-grid-column
        dataField="tnt_dsply_nm"
        caption="ULB Name"
        [minWidth]="150"
        cellTemplate="ulbLinkTemplate"
      ></app-grid-column>

      <app-grid-column
        dataField="ttl_vhcls"
        caption="Total Veh."
        [minWidth]="85"
        alignment="center"
      ></app-grid-column>

      <app-grid-column
        dataField="trps_asgnd_vhcls"
        caption="Trips Def."
        [minWidth]="85"
        alignment="center"
      ></app-grid-column>

      <app-grid-column
        dataField="trps_not_asgnd_vhcls"
        caption="Trips Not Def."
        [minWidth]="100"
        alignment="center"
      ></app-grid-column>

      <app-grid-column
        dataField="rts_dfnd_vhcls"
        caption="Routes Def. Veh"
        [minWidth]="100"
        alignment="center"
      ></app-grid-column>

      <app-grid-column
        dataField="rts_not_dfnd_vhcls"
        caption="Routes Not Def. Veh"
        [minWidth]="115"
        alignment="center"
      ></app-grid-column>

      <app-grid-column
        dataField="def_trps"
        caption="Defined"
        [minWidth]="75"
        alignment="center"
      ></app-grid-column>

      <app-grid-column
        dataField="trvl_trps"
        caption="Travelled"
        [minWidth]="80"
        alignment="center"
      ></app-grid-column>

      <app-grid-column
        dataField="nt_trvl_trps"
        caption="Not Trvld"
        [minWidth]="80"
        alignment="center"
      ></app-grid-column>

      <app-grid-column
        dataField="rts_dfnd"
        caption="Routes Def."
        [minWidth]="80"
        alignment="center"
      ></app-grid-column>

      <app-grid-column
        dataField="trckd_rts"
        caption="Tracked"
        [minWidth]="75"
        alignment="center"
      ></app-grid-column>

      <app-grid-column
        dataField="rte_dvtd"
        caption="Deviated"
        [minWidth]="75"
        alignment="center"
      ></app-grid-column>

      <ng-template appGridCell="ulbLinkTemplate" let-data="cell"
        ><div>
          <a class="ulb-link" (click)="onUlbClick(data.data)">{{
            data.value || data.data.tnt_nm
          }}</a>
        </div></ng-template
      >
    </app-data-grid>

    @if (!allUlbWiseData || allUlbWiseData.length == 0) {
    <div class="empty-state">
      <i nz-icon nzType="inbox" nzTheme="outline"></i>
      <p>No ULB-wise data available</p>
    </div>
    }
  </div>

  <!-- Vehicle-wise Detail Table (Card Drilldown) -->
  @if (showVhclTable) {
  <div class="vhcl-detail-section" id="vhclDetailSection">
    <!-- Loading -->
    @if (vhclTableLdr) {
    <div class="text-center py-8">
      <nz-spin nzSimple></nz-spin>
    </div>
    }
    <!-- dx-data-grid -->
    @if (!vhclTableLdr) {
    <div
      class="bg-white rounded-lg mb-4 overflow-hidden"
      style="
        border: 1px solid #e5e7eb;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
      "
      id="vhclGridTable"
    >
      <div
        class="flex items-center justify-between gap-2 px-4 py-2.5"
        style="border-bottom: 1px solid #f1f5f9"
      >
        <div class="flex items-center gap-2">
          <div
            class="flex items-center justify-center"
            style="
              width: 28px;
              height: 28px;
              background: #f1f5f9;
              border-radius: 6px;
            "
          >
            <svg
              style="width: 14px; height: 14px; color: #475569"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
              ></path>
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
              ></path>
            </svg>
          </div>
          <span
            style="
              font-size: 14px;
              font-weight: 600;
              text-transform: uppercase;
              letter-spacing: 0.3px;
            "
            >Vehicle Wise Details</span
          >
          <span class="vhcl-badge">{{ selectedCardLabel }}</span>
          @if (vhclWiseData && vhclWiseData.length > 0) {
          <span class="vhcl-count-badge"
            >{{ vhclWiseData.length }} vehicles</span
          >
          }
        </div>
        <button
          class="vhcl-close-btn"
          (click)="
            showVhclTable = false; selectedCard = ''; selectedCardLabel = ''
          "
        >
          <i nz-icon nzType="close" nzTheme="outline"></i>
        </button>
      </div>
      <app-data-grid
        style="width: 100%; max-width: 100% !important"
        [dataSource]="vhclWiseData"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="false"
        [allowExport]="true"
        exportFileName="Vehicle Wise Details"
        [pageSize]="10"
        [allowedPageSizes]="[10, 20, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="true"
      >
        <app-grid-column
          dataField="sno"
          caption="S.No"
          [minWidth]="55"
          [width]="60"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="asrt_nm"
          caption="Vehicle Name"
          [minWidth]="130"
        ></app-grid-column>
        <app-grid-column
          dataField="tnt_dsply_nm"
          caption="ULB"
          [minWidth]="130"
        ></app-grid-column>
        <app-grid-column
          dataField="trp_sqnc_nu"
          caption="Trip #"
          [minWidth]="60"
          alignment="center"
          [visible]="isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="schdle_strt_tm"
          caption="Sch. Start"
          [minWidth]="85"
          alignment="center"
          [visible]="isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="schdle_end_tm"
          caption="Sch. End"
          [minWidth]="85"
          alignment="center"
          [visible]="isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="actl_strt_tm"
          caption="Act. Start"
          [minWidth]="85"
          alignment="center"
          [visible]="isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="actl_end_tm"
          caption="Act. End"
          [minWidth]="85"
          alignment="center"
          [visible]="isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="trip_sts"
          caption="Status"
          [minWidth]="95"
          alignment="center"
          [visible]="isTripLevel"
          cellTemplate="tripStsTemplate"
        ></app-grid-column>
        <app-grid-column
          dataField="rte_dfnd_yn"
          caption="Rte Defined"
          [minWidth]="90"
          alignment="center"
          [visible]="isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="rte_trckd_yn"
          caption="Rte Tracked"
          [minWidth]="90"
          alignment="center"
          [visible]="isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="rte_dvtd_yn"
          caption="Rte Deviated"
          [minWidth]="95"
          alignment="center"
          [visible]="isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="def_trps"
          caption="Defined"
          [minWidth]="80"
          alignment="center"
          [visible]="!isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="trvl_trps"
          caption="Travelled"
          [minWidth]="80"
          alignment="center"
          [visible]="!isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="nt_trvl_trps"
          caption="Not Travelled"
          [minWidth]="95"
          alignment="center"
          [visible]="!isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="rts_dfnd"
          caption="Routes Defined"
          [minWidth]="95"
          alignment="center"
          [visible]="!isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="rts_not_dfnd"
          caption="Routes Not Def."
          [minWidth]="100"
          alignment="center"
          [visible]="!isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="trckd_rts"
          caption="Tracked"
          [minWidth]="75"
          alignment="center"
          [visible]="!isTripLevel"
        ></app-grid-column>
        <app-grid-column
          dataField="rte_dvtd"
          caption="Deviated"
          [minWidth]="75"
          alignment="center"
          [visible]="!isTripLevel"
        ></app-grid-column>
        <ng-template appGridCell="tripStsTemplate" let-data="cell"
          ><div>
            <span
              class="trip-sts-badge"
              [ngClass]="{
                'sts-completed': data.value === 'Completed',
                'sts-running': data.value === 'Running',
                'sts-initiated': data.value === 'Initiated',
                'sts-not-started': data.value === 'Not Started'
              }"
              >{{ data.value }}</span
            >
          </div></ng-template
        >
      </app-data-grid>
      @if (!vhclWiseData || vhclWiseData.length == 0) {
      <div class="empty-state">
        <i nz-icon nzType="inbox" nzTheme="outline"></i>
        <p>No vehicle data found for the selected category</p>
      </div>
      }
    </div>
    }
  </div>
  }
</div>
